import React from 'react'; 
import './Process.css';

import { Heading, ProcessStep } from '../../../components';
import { process } from '../../../constants';

// import Swiper core and required modules 
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Process = () => {

  return (

    <section>

      {/* Section heading */}
      <Heading title={'WorkFlow Process'} subTitle={'How We Work'} />

      <div className='process-slider'>

        <Swiper
          // install Swiper modules
          modules={[Autoplay]}
          spaceBetween={10} // Space between slides
          loop={true} // Enable infinite loop
          autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
          breakpoints= {{
            0: { 
              slidesPerView: 1, // Show 1 slide on small screens
            },
            768: {
              slidesPerView: 2, // Show 2 slides on tablets
            },
            991: {
              slidesPerView: 3, // Show 3 slides on medium screens
            },
            1200: {
              slidesPerView: 4, // Show 4 slides on larger screens
            }
          }}
        >
          {// Mapping through the process array to create slides
            process.map((step, index) => {
              return (
                <SwiperSlide key={index}>

                  <ProcessStep step={step} />

                </SwiperSlide>
              )
            })
          }

        </Swiper>

      </div>

    </section>

  );
}

export default Process;